import { html } from "lit";
var icon_getty_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.5 5.27c-1.13 0-2.37 0-3.11.47a5.93 5.93 0 0 1 1.09 3.58c0 3.8-2.57 6.53-7.62 6.53-2.1 0-3.77.08-3.77 1.24 0 3.27 13.3-1.16 13.3 6.92 0 2.88-2.92 5.99-9.37 5.99C10.57 30 7 28.37 7 25.18c0-2.53 1.9-3.73 3.65-3.73v-.08c-.93-.58-2.99-1.1-2.99-3.27 0-1.94 2.25-3.42 3.15-3.7-1.67-1.35-3-2.9-3-5.36 0-3.53 2.73-7.03 7.97-7.03 1.71 0 3.73.7 4.98 1.78.93-1.24 2.45-1.86 4.74-1.78v3.26ZM11.43 24.56c0 1.55 1.32 2.25 5.37 2.25 3.1 0 4.15-1.55 4.15-2.25 0-.94-1.44-2.34-6.1-2.34-2.64 0-3.42 1.48-3.42 2.34Zm7.62-15.63a3.37 3.37 0 0 0-3.4-3.35c-1.88 0-3.4 1.5-3.4 3.35a3.37 3.37 0 0 0 3.4 3.34c1.88 0 3.4-1.5 3.4-3.34Z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_getty_default as default
};
//# sourceMappingURL=icon-getty.js.map
